import {
	adminClient,
	apiKeyClient,
	genericOAuthClient,
	magicLinkClient,
	organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { ac, admin, user } from "./auth-permissions";

export const authClient = createAuthClient({
	baseURL: `${window.location.origin}/api/auth`,
	plugins: [
		apiKeyClient(),
		// Spec 23: genericOAuthClient surfaces signIn.oauth2() for the
		// "Continue with Codespring" button. Server-side plugin gates
		// whether codespring is actually registered.
		genericOAuthClient(),
		// Spec 24: magicLinkClient surfaces signIn.magicLink() so the
		// /login email-input flow can POST a sign-in request.
		magicLinkClient(),
		adminClient({
			ac,
			roles: { admin, user },
		}),
		// Spec 30 PR 2: workspaces as organizations. Surfaces
		// authClient.organization.list() / setActive() / inviteMember()
		// etc. on the client.
		organizationClient(),
	],
});

export const { signIn, signUp, signOut, useSession } = authClient;
